// import Blog1 from "./../assets/blog/11.png";
import Blog2 from "./../assets/blog/12.webp";
import Blog3 from "./../assets/blog/13.webp";
import Blog2Url from "./../assets/pdf/patent.pdf";
import Blog3Url from "./../assets/pdf/marka.pdf";
// import Blog4 from "./../assets/blog/14.png";
const blogData = {
  blogs: [
    // {
    //   id: 1005,
    //   title: "",
    //   desc: "",
    //   date: "",
    //   category: [""],
    //   images: Blog1,
    //   writer: "mukemel",
    // },
    {
      id: 1006,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Blog2,
      writer: "blog2",
      url: Blog2Url,
    },
    {
      id: 1007,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Blog3,
      writer: "blog3",
      url: Blog3Url,
    },
    // {
    //   id: 1008,
    //   title: "",
    //   desc: "",
    //   date: "",
    //   category: [""],
    //   images: Blog4,
    //   writer: "blog4",
    // },
  ],
};

export default blogData;
